import {targets, useReferentialContext} from "../../Context";
import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import {HighlightScope, pieArcLabelClasses, PieChart} from "@mui/x-charts";


export default function Proximities(props: {paramObject: any, target: targets, timer:string}) {
    const api = useReferentialContext().farsightApi.getSummariesApi(props.target);
    const [prox, setProx] = useState(undefined as any);
    const [highlighted, setHighlighted] = useState('item');
    const [faded, setFaded] = useState('global');

    const labels = [
        [`toplane_proximity_${props.timer}__avg`, 'Top'],
        [`jungle_proximity_${props.timer}__avg`, 'Jungle'],
        [`midlane_proximity_${props.timer}__avg`, 'Mid'],
        [`botlane_proximity_${props.timer}__avg`, 'Adc'],
        [`support_proximity_${props.timer}__avg`, 'Support'],
    ]

    useEffect(() => {
        api.aggregate(
            {
                ...props.paramObject,
                groupby: ['player'],
                aggregates:['toplane_proximity_pre15__avg,jungle_proximity_pre15__avg,midlane_proximity_pre15__avg,botlane_proximity_pre15__avg,support_proximity_pre15__avg,toplane_proximity_post15__avg,jungle_proximity_post15__avg,midlane_proximity_post15__avg,botlane_proximity_post15__avg,support_proximity_post15__avg'],
                ordering:['toplane_proximity_pre15__avg']
            }
        ).then(result => setProx(result[0]))
        // FarsightApi.get_request("PlayerPerformanceEvolution", props).then((data) => setRows(data));
        // fetch(api_url + "PlayerPerformanceEvolution/?player=" + player + "&format=json").then(response => response.json()).then(data => setRows(data));
    }, [props.paramObject.watermark]);



    return prox ? (
        <Box component={"fieldset"}
             sx={{
                 borderRadius: 3,
                 height: "90%",
                 width: "100%",
                 alignItems: "center",
                 justifyContent: "center",
                 display: "flex"
             }}
        >
            <Box sx={{width:'100%', height:'100%'}}>
                <PieChart
                    series={[
                        {
                            type: 'pie',
                            innerRadius: 70,
                            outerRadius: 120,
                            // data: data.map((e: any) => {return {label: `${e.champion}`, getValue: e.win__sum}}),
                            data: labels.map((v, index) => {return {label: v[1], value: prox[v[0]] >= 0.9 ? 0 : prox[v[0]]}}),
                            highlighted: { additionalRadius: 10 },
                            highlightScope: {
                                highlighted,
                                faded,
                            } as HighlightScope,
                            paddingAngle: 2,
                            cornerRadius: 5,
                            arcLabel: (item) => `${item.label} \n ${(item.value*100).toFixed(2)}%`,
                            arcLabelMinAngle: 20,
                        },
                    ]}
                    margin={{ top: 0, left: 0, right: 0, bottom: 0 }}
                    slotProps={{
                        legend: {
                            hidden: true,
                            itemMarkWidth: 20,
                            itemMarkHeight: 2,
                            markGap: 5,
                            itemGap: 10,
                            labelStyle: {
                                fontSize: 14,
                                fill: 'blue',
                            },
                        },

                    }}
                    sx={{
                        [`& .${pieArcLabelClasses.root}`]: {
                            fill: 'white',
                            fontWeight: 'bold',
                        },
                    }}
                ></PieChart>
            </Box>
        </Box>
    ) : <></>;
}